import { authHeader, history } from "../_helpers";
import { handleResponse } from "../_helpers/response";
import config from "../config";
import axios from "axios";
const baseUrl = config.apiGateway.baseUrl;

function checkWantedGuna(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };
  return fetch(`${baseUrl}/criminal/checkWantedGuna`, requestOptions).then(
    handleResponse
  );
}
function createWantedNotification(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };
  return fetch(
    `${baseUrl}/criminal/createWantedNotification`,
    requestOptions
  ).then(handleResponse);
}
function updateWantedNotificationReadBy(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };
  return fetch(
    `${baseUrl}/criminal/updateWantedNotificationReadBy`,
    requestOptions
  ).then(handleResponse);
}
function getWantedNotificationList(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };
  return fetch(
    `${baseUrl}/criminal/getWantedNotificationList`,
    requestOptions
  ).then(handleResponse);
}

export const wantedNotificationService = {
  checkWantedGuna,
  createWantedNotification,
  getWantedNotificationList,
  updateWantedNotificationReadBy,
};
